import { motion } from "framer-motion";
import { FileText, Plus } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SIGNATURE_ITEMS, eur } from "../lib/menuData";
import { useCart } from "../context/CartContext";

const SigRow = ({ item }) => {
  const { add } = useCart();
  return (
    <div className="flex items-center gap-4 border border-gold/15 bg-teal-deep/50 rounded-sm px-5 py-4" data-testid={`sig-row-${item.n}`}>
      <div className="min-w-0 flex-1">
        <div className="flex items-baseline gap-2 flex-wrap">
          <h4 className="font-serif text-xl text-cream leading-tight">{item.name}</h4>
          {item.a && <span className="text-[0.62rem] text-gold/50 tracking-wide">[{item.a}]</span>}
        </div>
        <p className="text-cream/55 text-sm mt-1">{item.desc}</p>
      </div>
      <span className="font-serif text-xl text-gold whitespace-nowrap">{eur(item.p)}</span>
      <button data-testid={`add-${item.n}`} onClick={() => add(item)}
        aria-label={`${item.name} in den Warenkorb`}
        className="h-9 w-9 shrink-0 rounded-full bg-gold text-teal-dark flex items-center justify-center hover:bg-gold-light hover:scale-110 transition-all">
        <Plus size={18} />
      </button>
    </div>
  );
};

export const FlyerSection = () => (
  <section id="signatures" className="relative bg-teal-dark py-24 md:py-36 grain">
    <div className="relative z-10 max-w-6xl mx-auto px-5 md:px-10">
      <div className="text-center flex flex-col items-center mb-14">
        <Overline className="mb-5 justify-center">Neu · Unsere Empfehlung</Overline>
        <Reveal>
          <h2 className="font-serif text-4xl sm:text-5xl md:text-6xl text-cream leading-tight">
            Ceylon <span className="italic text-gold">Signatures</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-5 text-cream/65 max-w-lg">
            Unsere besonderen Kreationen – Rainbow Idli Box & Idiyappam Kottu.
          </p>
        </Reveal>
      </div>

      <div className="grid lg:grid-cols-2 gap-10 lg:gap-14 items-start">
        <Reveal delay={0.12}>
          <motion.a
            href="/ceylon-signatures.pdf" target="_blank" rel="noopener noreferrer"
            data-testid="flyer-image-link"
            whileHover={{ scale: 1.01 }}
            className="block rounded-lg overflow-hidden border border-gold/25 shadow-2xl"
          >
            <img src="/ceylon-signatures.jpg" alt="Ceylon Signatures – Rainbow Idli Box & Idiyappam Kottu"
              className="w-full h-auto block" />
          </motion.a>
          <div className="mt-6 flex justify-center lg:justify-start">
            <a href="/ceylon-signatures.pdf" target="_blank" rel="noopener noreferrer"
              data-testid="flyer-pdf-btn"
              className="inline-flex items-center gap-2 border border-gold/40 text-gold px-6 py-3 rounded-full font-medium hover:bg-gold/10 transition-colors">
              <FileText size={18} /> Flyer als PDF öffnen
            </a>
          </div>
        </Reveal>

        <Reveal delay={0.18}>
          <div className="space-y-3">
            {SIGNATURE_ITEMS.map((item) => <SigRow key={item.n} item={item} />)}
            <p className="text-cream/45 text-xs pt-2">
              Preise inkl. MwSt. Tippe auf <span className="inline-flex items-center justify-center h-4 w-4 rounded-full bg-gold text-teal-dark align-middle"><Plus size={11} /></span>, um zu bestellen.
            </p>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
